const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function getEmployees({ per_page, status, search } = {}) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     let url = `${BASE_URL}/getEmployees`;
     const params = new URLSearchParams();
     if (per_page) params.set('per_page', per_page);
     if (status) params.set('status', status);
     if (search) params.set('search', search);
     const query = params.toString();
     if (query) url += `?${query}`;
     const response = await fetch(url, {
          method: 'GET',
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     });
     if (!response.ok) throw new Error('Failed to fetch employees');
     return response.json();
}


// export async function getEmployeesForMaster() {
//      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
//      const response = await fetch(`${BASE_URL}/getEmployeesForMaster`, {
//           method: 'GET',
//           headers: {
//                'Authorization': `Bearer ${token}`,
//                'Content-Type': 'application/json'
//           }
//      });
//      if (!response.ok) throw new Error('Failed to fetch employees for master');
//      return response.json();
// }

export const getEmployeesForMaster = async ({ per_page = 0, status = 'A', search = '', page = 1 } = {}) => {
     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const params = new URLSearchParams();
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     // per_page: backend expects 0 for "all", otherwise pass numeric
     if (per_page !== undefined && per_page !== null) params.set('per_page', per_page);
     if (status) params.set('status', status);
     if (search) params.set('search', search);
     if (page !== undefined && page !== null) params.set('page', page);
     const url = `${BASE_URL}/getEmployeesForMaster?${params.toString()}`;
     // optional: add auth header if required
     const res = await fetch(url, {
          method: 'GET',
          headers: {
               'Accept': 'application/json',
               'Authorization': `Bearer ${token}` // if needed
          }
     });
     return res.json();
};

export async function activateEmployee(employeeCode) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     const response = await fetch(`${BASE_URL}/updateEmployeeStatus`, {
          method: 'POST',
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          },
          body: JSON.stringify({ employee_code: employeeCode, status: "Active" })
     });
     if (!response.ok) throw new Error('Failed to activate employee');
     return response.json();
}

// getEmployeesWithLeaveApplicable
export async function getEmployeesWithLeaveApplicable() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     const response = await fetch(`${BASE_URL}/getEmployeesWithLeaveApplicable`, {
          method: 'GET',
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     });
     if (!response.ok) throw new Error('Failed to fetch employees with leave applicable');
     return response.json();
}

// Reset travel master passwords for selected employee codes
export async function resetTravelMasterPasswords(employee_codes) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     const response = await fetch(`${BASE_URL}/resetTravelMasterPasswords`, {
          method: 'POST',
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          },
          body: JSON.stringify({ employee_codes })
     });
     const result = await response.json();
     if (!response.ok) {
          throw new Error(result.message || 'Failed to reset travel master passwords');
     }
     return result;
}

export async function createNewEmployee(data) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     const response = await fetch(`${BASE_URL}/createNewEmployee`, {
          method: 'POST',
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
     });
     if (!response.ok) throw new Error('Failed to create employee');
     return response.json();
}

export async function getEmployeeById(id) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     const response = await fetch(`${BASE_URL}/getEmployeeById/${id}`, {
          method: 'GET',
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     });
     if (!response.ok) throw new Error('Failed to fetch employee by ID');
     return response.json();
}

export async function getEmployeeByEmpCode(empcode) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     try {
          const response = await fetch(`${BASE_URL}/getEmployeeByEmpCode/${empcode}`, {
               method: 'GET',
               headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
               }
          });
          if (response.status === 404) {
               // Employee not found, return null or a special object
               return null;
          }
          if (!response.ok) {
               // Try to extract error message from response
               let errorMsg = 'Failed to fetch employee by code';
               try {
                    const errData = await response.json();
                    if (errData && errData.message) errorMsg = errData.message;
               } catch { }
               throw new Error(errorMsg + ` (HTTP ${response.status})`);
          }
          return response.json();
     } catch (error) {
          // Network or other errors
          throw new Error(error.message || 'Network error while fetching employee by code');
     }
}

export async function updateEmployee(id, data) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     const response = await fetch(`${BASE_URL}/updateEmployee/${id}`, {
          method: 'POST',
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
     });
     if (!response.ok) throw new Error('Failed to update employee');
     return response.json();
}

export const deleteEmployee = async (employeeCode) => {
     try {
          const token = sessionStorage.getItem('token') || localStorage.getItem('token');
          const response = await fetch(`${BASE_URL}/deleteEmployee/${employeeCode}`, {
               method: 'DELETE',
               headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
               },
          });
          const result = await response.json();

          if (!response.ok) {
               throw new Error(result.message || 'Failed to delete employee');
          }
          return result;
     } catch (error) {
          console.error('Error deleting employee:', error);
          throw error;
     }
};

// Each API function uses fetch directly with headers
export function getCity() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getCity`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getLocation() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getLocation`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getCluster() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getCluster`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getDeptCategory() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getDeptCategory`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getMainDept() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getMainDept`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getSubDept() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getSubDept`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getReligion() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getReligion`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getCaste() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getCaste`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}



export function getDegree() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getDegree`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getBloodGroup() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getBloodGroup`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getOrgan() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getOrgan`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getGrade() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getGrade`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserCalen() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserCalen`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserModes() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserModes`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserDesign() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserDesign`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserPosit() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserPosit`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserDept() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserDept`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserSubDept() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserSubDept`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserPayGroup() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserPayGroup`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserCurrency() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserCurrency`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserJobProfile() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserJobProfile`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserPaymentType() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserPaymentType`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserAccount() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserAccount`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserBank() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserBank`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getBranch() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getBranch`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserWorkType() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserWorkType`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserMedRegCouncil() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserMedRegCouncil`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserEarningName() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserEarningName`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserDeductionName() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserDeductionName`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserLoanType() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserLoanType`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserLeaveTemplate() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserLeaveTemplate`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserAirTicketTemplate() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserAirTicketTemplate`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserState() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserState`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}

export function getUserReasonForLeaving() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getUserReasonForLeaving`, {
          headers: {
               'Authorization': `Bearer ${token}`,
               'Content-Type': 'application/json'
          }
     }).then(res => res.json());
}



export function getDoctorShifts() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');

     return fetch(`${BASE_URL}/getDoctorShifts`, {
          method: 'GET',
          headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`
          }
     }).then(res => res.json());
}


export function getDoctorsSplitShifts() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getDoctorsSplitShifts`, {
          method: 'GET',
          headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`
          }
     }).then(res => res.json());
}


export function getDoctorShiftById(shiftId) {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');

     return fetch(`${BASE_URL}/getDoctorShiftById/${shiftId}`, {
          method: 'GET',
          headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`
          }
     }).then(res => {
          if (!res.ok) {
               throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
     });
}



export function getShifts() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');

     return fetch(`${BASE_URL}/getShifts`, {
          method: 'GET',
          headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`
          }
     }).then(res => res.json());
}

// $routes->match(['GET', 'OPTIONS'], 'getSplitShifts', 'DutyRoster::getSplitShifts', ['filter' => 'jwt']);

export function getSplitShifts() {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     return fetch(`${BASE_URL}/getSplitShifts`, {
          method: 'GET',
          headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`
          }
     }).then(res => res.json());
}



